/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        const LOG_CATEGORY = "WPT.Navigation.Detail";
        // Context from which the layout activation was called
        // This should specifically be the entity which was *clicked*
        // Actually this is becoming a full-on messaging interface, so there are many options here
        let LayoutActivationType;
        (function (LayoutActivationType) {
            // General items
            LayoutActivationType["UNKNOWN"] = "UNKNOWN";
            LayoutActivationType["NONE"] = "NONE";
            LayoutActivationType["OTHER"] = "OTHER";
            // Document activities
            LayoutActivationType["DOCUMENT_SELECTED"] = "DOCUMENT_SELECTED";
            LayoutActivationType["DOCUMENT_DESELECTED"] = "DOCUMENT_DESELECTED";
            LayoutActivationType["DOCUMENT_UPLOADED"] = "DOCUMENT_UPLOADED";
            LayoutActivationType["DOCUMENT_DELETED"] = "DOCUMENT_DELETED";
            LayoutActivationType["DOCUMENT_REVISED"] = "DOCUMENT_REVISED";
            LayoutActivationType["DOCUMENT_PRINTED"] = "DOCUMENT_PRINTED";
            LayoutActivationType["DOCUMENT_ENTERED_WF"] = "DOCUMENT_ENTERED_WF";
            LayoutActivationType["DOCUMENT_KEYWORDS_UPDATED"] = "DOCUMENT_KEYWORDS_UPDATED";
            LayoutActivationType["DOC_REQUIREMENTS_MET"] = "DOC_REQUIREMENTS_MET";
            LayoutActivationType["DOC_REQUIREMENTS_NOT_MET"] = "DOC_REQUIREMENTS_NOT_MET";
            // Related document activities
            LayoutActivationType["RELATED_UPLOAD_REQUEST"] = "RELATED_UPLOAD_REQUEST";
            // Document type activities
            LayoutActivationType["DOCTYPE_SELECTED_UPLOAD"] = "DOCTYPE_SELECTED_UPLOAD";
            LayoutActivationType["DOCTYPES_SELECTED_SEARCH"] = "DOCTYPES_SELECTED_SEARCH";
            LayoutActivationType["DOCTYPE_DESELECTED"] = "DOCTYPE_DESELECTED";
            // Query handling
            LayoutActivationType["QUERY_SELECTED"] = "QUERY_SELECTED";
            LayoutActivationType["QUERY_DESELECTED"] = "QUERY_DESELECTED";
            LayoutActivationType["QUERY_NO_DOCUMENTS"] = "QUERY_NO_DOCUMENTS";
            LayoutActivationType["QUERY_REQUESTED"] = "QUERY_REQUESTED";
            LayoutActivationType["QUERY_DEFINITION"] = "QUERY_DEFINITION";
            LayoutActivationType["QUERY_RESULT_DOCUMENTS"] = "QUERY_RESULT_DOCUMENTS";
            // Form handling
            LayoutActivationType["FORM_SELECTED"] = "FORM_SELECTED";
            LayoutActivationType["FORM_SUBMITTED"] = "FORM_SUBMITTED";
            // Other OnBase document management schema items
            LayoutActivationType["FOLDER_SELECTED"] = "FOLDER_SELECTED";
            LayoutActivationType["ENVELOPE_SELECTED"] = "ENVELOPE_SELECTED";
            LayoutActivationType["NOTE_CREATED"] = "NOTE_CREATED";
            // Workflow
            LayoutActivationType["WORKFLOW_QUEUE_SELECTED"] = "WORKFLOW_QUEUE_SELECTED";
            LayoutActivationType["WORKFLOW_ACTION_FIRED"] = "WORKFLOW_ACTION_FIRED";
            LayoutActivationType["WORKFLOW_NO_ITEMS"] = "WORKFLOW_NO_ITEMS";
            LayoutActivationType["WORKFLOW_PSEUDO_SYSTASK"] = "WORKFLOW_PSEUDO_SYSTASK";
            // WorkView
            LayoutActivationType["WV_CLASS_SELECTED"] = "WV_CLASS_SELECTED";
            LayoutActivationType["WV_FILTER_SELECTED"] = "WV_FILTER_SELECTED";
            LayoutActivationType["WV_OBJECT_SELECTED"] = "WV_OBJECT_SELECTED";
            LayoutActivationType["WV_OBJECT_DESELECTED"] = "WV_OBJECT_DESELECTED";
            LayoutActivationType["WV_OBJECT_UPDATED"] = "WV_OBJECT_UPDATED";
            LayoutActivationType["WV_OBJECT_DELETED"] = "WV_OBJECT_DELETED";
            LayoutActivationType["WV_ACTION_FIRED"] = "WV_ACTION_FIRED";
            // User profile/favourites etc.
            LayoutActivationType["FAVOURITE_ADDED"] = "FAVOURITE_ADDED";
            // User Admin
            LayoutActivationType["USER_SELECTED"] = "USER_SELECTED";
            LayoutActivationType["USER_LIST"] = "USER_LIST";
            LayoutActivationType["USER_GROUP_SELECTED"] = "USER_GROUP_SELECTED";
            LayoutActivationType["USER_GROUP_LIST"] = "USER_GROUP_LIST";
            // User interface events
            LayoutActivationType["WIDGET_COLLAPSED"] = "WIDGET_COLLAPSED";
            LayoutActivationType["WIDGET_EXPANDED"] = "WIDGET_EXPANDED";
            LayoutActivationType["WIDGET_CLOAKED"] = "WIDGET_CLOAKED";
            LayoutActivationType["WIDGET_DECLOAKED"] = "WIDGET_DECLOAKED";
            LayoutActivationType["DISPLAY_DOC_PROPS"] = "DISPLAY_DOC_PROPS";
            // System Events
            LayoutActivationType["TIMER_TICK"] = "TIMER_TICK";
            LayoutActivationType["RETURNED_TO_HOME_VIEW"] = "RETURNED_TO_HOME_VIEW";
            LayoutActivationType["BATCH_PROCESS_COMPLETE"] = "BATCH_PROCESS_COMPLETE";
            LayoutActivationType["DATASET_PUBLISHED"] = "DATASET_PUBLISHED";
            // System Requests
            LayoutActivationType["REQUEST_TO_ADVERTISE"] = "REQUEST_TO_ADVERTISE";
            LayoutActivationType["REQUEST_DOC_UPLOAD_INFO"] = "REQUEST_DOC_UPLOAD_INFO";
            LayoutActivationType["REQUEST_STATUS"] = "REQUEST_STATUS";
            // System Responses
            LayoutActivationType["RESPONSE_SERVICE_PROVIDED"] = "RESPONSE_SERVICE_PROVIDED";
            LayoutActivationType["RESPONSE_CAPABILITY_PUBLISHED"] = "RESPONSE_CAPABILITY_PUBLISHED";
            LayoutActivationType["RESPONSE_UPLOAD_DOCTYPE"] = "RESPONSE_UPLOAD_DOCTYPE";
            LayoutActivationType["RESPONSE_UPLOAD_KEYWORDS"] = "RESPONSE_UPLOAD_KEYWORDS"; // Keyword (and property) list for document upload published
        })(LayoutActivationType = Navigation.LayoutActivationType || (Navigation.LayoutActivationType = {}));
        // Needs to be a string enum for functionality to work!
        let LayoutInitialisationStatus;
        (function (LayoutInitialisationStatus) {
            LayoutInitialisationStatus["NONE"] = "NONE";
            LayoutInitialisationStatus["LOADING_RESOURCES"] = "LOADING_RESOURCES";
            LayoutInitialisationStatus["LOADED_RESOURCES"] = "LOADED_RESOURCES";
            LayoutInitialisationStatus["PERFORMING_LAYOUT"] = "PERFORMING_LAYOUT";
            LayoutInitialisationStatus["CREATING_WIDGETS"] = "CREATING_WIDGETS";
            LayoutInitialisationStatus["WIDGETS_ACTIVE"] = "WIDGETS_ACTIVE";
            LayoutInitialisationStatus["ACTIVE"] = "ACTIVE";
            LayoutInitialisationStatus["DEACTIVATING"] = "DEACTIVATING";
            LayoutInitialisationStatus["DORMANT"] = "DORMANT";
        })(LayoutInitialisationStatus = Navigation.LayoutInitialisationStatus || (Navigation.LayoutInitialisationStatus = {}));
        /*
        * Holds context switching information
        */
        class WidgetTransferRequest {
            constructor(instance) {
                this.Instance = instance;
                this.IsActivatingWidget = false;
                this.SelectedPlaceholder = null;
            }
        }
        Navigation.WidgetTransferRequest = WidgetTransferRequest;
        class ActivationContext {
            constructor(activator, activationContext) {
                // Complex info: Objects need to support activation
                this.PrimaryContext = null;
                // Some scenarios benefit from sending a bunch of extra objects or info, e.g. workflow queue doc list
                this.AdditionalContext = {};
                // Application context slots to populate (or clear) when selecting documents or objects
                this.Slots = null;
                // List of widgets to bring across
                this.TransferWidgets = null;
                // Added automatically by the navigation handler
                this.TargetDIV = null;
                // Forces a stealthed widget to show itself to comply with the contect request
                this.Decloak = false;
                // Forces a view to reload even if it is already the current view or cached
                this.ForceReload = false;
                // Allows original requestor to be called back when the event has finished processing
                this.FinalCallbacks = [];
                // Allows targets of this context to insert status feedback
                this.Feedback = [];
                this.addTransferWidget = (instance) => {
                    // Filter out the activating widget, we don't want to mess with it twice
                    let request = new WidgetTransferRequest(instance);
                    this.TransferWidgets.push(request);
                };
                this.ActivatingWidget = activator;
                this.ActivationType = activationContext;
                this.TransferWidgets = [];
                this.Slots = [];
                if (activator) {
                    let request = new WidgetTransferRequest(activator);
                    request.IsActivatingWidget = true;
                    this.TransferWidgets.push(request);
                }
            }
            populateTransferList(transferRecords, core) {
                let currentLayoutName = core.Navigation.Details.getActiveLayoutName();
                transferRecords.forEach(record => {
                    let instance = null;
                    if (record.SourceLayoutIsHome) {
                        instance = core.Widgets.getInstanceByHandle(`Home.${record.SourcePlaceholder}`);
                    }
                    else {
                        instance = core.Navigation.Details.getActiveLayout().getWidgetInstanceByPlaceholder(record.SourcePlaceholder);
                    }
                    if (instance && this.ActivatingWidget && (instance.Handle != this.ActivatingWidget.Handle)) {
                        let request = new WidgetTransferRequest(instance);
                        this.TransferWidgets.push(request);
                    }
                });
            }
        } // export class ActivationContext
        Navigation.ActivationContext = ActivationContext;
        /*
        * Used to handle initialisation and status changes.
        * ONLY queues one callback per status - child classes of the DetailLayoutBaseClass will need to use super
        */
        class LayoutStatusCallbackHandler {
            constructor() {
                this.getStatus = () => { return this._status; };
                this.setStatus = (status) => {
                    
                    if (status != null)
                        this._status = status;
                    if (this._callbackmap[status] != null)
                        this._callbackmap[status].call();
                };
                this.setCallback = (status, callback, owner, args) => {
                    
                    // Note: use of the bind call should ensure "this" is respected even for non => functions
                    // Note: the '...' is the spread operator - it dynamically expands an array into arguments
                    this._callbackmap[status] = callback.bind(owner, ...args);
                };
                this.clearCallback = (status) => {
                    
                    this._callbackmap[status] = null;
                };
                this.allowWidgetActivations = () => {
                    
                    if (['CREATING_WIDGETS', 'WIDGETS_ACTIVE', 'ACTIVE'].indexOf(this._status) != -1)
                        return true;
                    else
                        return false;
                };
                this._status = LayoutInitialisationStatus.NONE;
                this._callbackmap = {};
                for (let item in LayoutInitialisationStatus) {
                    this._callbackmap[item] = null;
                }
            }
        } // class LayoutStatusCallbackHandler
        /*
        * Base class for detail layout handling - extend for specific layouts
        */
        class DetailLayoutBaseClass {
            constructor(typeName, core, handler, custom, context, readyCallback = null, secondaryActivationCallback = null) {
                this.Name = () => { return this._name; };
                this._log = null;
                this._handler = null;
                this._layoutHTML = null;
                this._containingDIV = null;
                this._config = null;
                this._userConfig = null;
                this._widgetConfigWorkingCopy = null;
                this._context = null;
                this._stashedContext = null;
                this._launchingContext = null; // Context stored for activate only (not secondary)
                // All widget instances owned by this layout
                this._instancesByPlaceholder = {};
                // Subset of widgets created and maintained by this layout
                this._localInstances = [];
                // Housekeeping
                this._internalName = null;
                this._htmlLoaded = false;
                this._configLoaded = false;
                this._widgetsReadyCallback = null;
                this._secondaryActivationCompleteCallback = null;
                this._receiveRemoteViewLayout = (response) => {
                    this._log.info("DetailLayoutBaseClass._receiveRemoteSpecificAppConfig()");
                    this.loadTemplate(response.ContentText);
                };
                // Housekeeping functions, taking them out of inline declaration. =======================================================
                // When both HTML and JSON are loaded, we can activate. Will always activate on first load as load is on demand.
                this.loadTemplate = (html) => {
                    this._log.info("DetailLayoutBaseClass.loadTemplate()");
                    this._layoutHTML = html;
                    this._htmlLoaded = true;
                    if (this._configLoaded) {
                        this._status.setStatus(LayoutInitialisationStatus.LOADED_RESOURCES);
                    }
                };
                this.loadConfig = (json) => {
                    this._log.info("DetailLayoutBaseClass.loadConfig()");
                    this._config = json;
                    this._configLoaded = true;
                    if (this._htmlLoaded) {
                        this._status.setStatus(LayoutInitialisationStatus.LOADED_RESOURCES);
                    }
                };
                this.initErrorCallback = (url, status, statusText) => {
                    this._log.info("DetailLayoutBaseClass.initErrorCallback()");
                    throw new Error(`Error encountered loading resources for layout ${this._name}:\n${statusText}`);
                };
                // We may have user-defined widgets set up at the application level. Merge these with our config prior
                // to widget creation.
                this._mergeWidgetConfiguration = () => {
                    this._log.info("DetailLayoutBaseClass._mergeWidgetConfiguration()");
                    // Make sure everything exists and is !null before trying to process
                    if (!this._config.Layout.hasOwnProperty('Widgets') || (this._config.Layout.Widgets == null)) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("_mergeWidgetConfiguration found no internally configured widgets - proceeding with empty list");
                        }
                        this._config.Layout.Widgets = {};
                    }
                    if (!this._userConfig.hasOwnProperty('Widgets') || (this._userConfig.Widgets == null)) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("_mergeWidgetConfiguration found no user-configured widgets - proceeding with empty list");
                        }
                        this._userConfig.Widgets = {};
                    }
                    // We need to start from scratch every time we are activated, so take a working copy
                    this._widgetConfigWorkingCopy = JSON.parse(JSON.stringify(this._config.Layout.Widgets));
                    // We also need a grid of instances by target placeholder to manage cross-instance clashes
                    // Usual reminder: widgetName is the string key, not the actual record
                    for (let widgetName in this._userConfig.Widgets) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`_mergeWidgetConfiguration checking '${widgetName}' in _userConfig`);
                        }
                        if (this._widgetConfigWorkingCopy.hasOwnProperty(widgetName)) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`_mergeWidgetConfiguration found '${widgetName}' in working copy`);
                            }
                            // Need to inject into instances - make sure they exist so we don't explode when trying to iterate
                            if (this._userConfig.Widgets[widgetName].hasOwnProperty('Instance') || (this._userConfig.Widgets[widgetName].Instance != null)) {
                                if (!this._widgetConfigWorkingCopy[widgetName].hasOwnProperty('Instance') || (this._widgetConfigWorkingCopy[widgetName].Instance == null)) {
                                    this._widgetConfigWorkingCopy[widgetName].Instance == [];
                                }
                                // Now iterate. Simply add if no clash, overwrite or block as configured if there is a clash
                                this._userConfig.Widgets[widgetName].Instance.forEach(instance => {
                                    let existing = this._widgetConfigWorkingCopy[widgetName].Instance.find(i => i.PlaceHolder == instance.PlaceHolder);
                                    if (existing) {
                                        if (!this._config.Layout.hasOwnProperty('PreventUserWidgetOverwrite') || (!this._config.Layout.PreventUserWidgetOverwrite)) {
                                            if (this._log.isTraceEnabled()) {
                                                this._log.trace(`DetailView overwriting widget ${existing.Title} with ${instance.Title} into ${existing.PlaceHolder}`);
                                            }
                                            this._widgetConfigWorkingCopy[widgetName].Instance[this._widgetConfigWorkingCopy[widgetName].Instance.indexOf(existing)] = instance;
                                        }
                                    }
                                    else {
                                        if (this._log.isTraceEnabled()) {
                                            this._log.trace(`DetailView inserting transferred widget ${instance.Title} into ${instance.PlaceHolder}`);
                                        }
                                        this._widgetConfigWorkingCopy[widgetName].Instance.push(instance);
                                    }
                                });
                            }
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`_mergeWidgetConfiguration did not find '${widgetName}' in working copy`);
                            }
                            // Check for disable at type level
                            if (this._userConfig.Widgets[widgetName].hasOwnProperty('Disabled') && this._userConfig.Widgets[widgetName].Disabled)
                                continue;
                            // Now we've before we pull the config, we still might be clashing with widgets of OTHER types but in the same placeholder
                            let activeWidgetsToInsert = false;
                            this._userConfig.Widgets[widgetName].Instance.forEach(instance => {
                                if (!instance.hasOwnProperty('Disabled') || !instance.Disabled) {
                                    for (let workingName in this._widgetConfigWorkingCopy) {
                                        let clashingInstance = this._widgetConfigWorkingCopy[workingName].Instance.find(wi => wi.PlaceHolder == instance.PlaceHolder);
                                        if (clashingInstance) {
                                            if (this._log.isTraceEnabled()) {
                                                this._log.trace(`DetailView widgets of type ${widgetName} and ${workingName} clashing over placeholder ${instance.PlaceHolder}`);
                                            }
                                            if (!this._config.Layout.hasOwnProperty('PreventUserWidgetOverwrite') || (!this._config.Layout.PreventUserWidgetOverwrite)) {
                                                // Disabling far easier than filtering the array and should do the same job
                                                clashingInstance.Disabled = true;
                                                activeWidgetsToInsert = true;
                                            }
                                            else
                                                instance.Disabled = true;
                                        }
                                        else {
                                            // Even if disabled, may as well insert and have the instantiation code clear it out
                                            activeWidgetsToInsert = true;
                                        }
                                    }
                                }
                            });
                            // No existing widgets of this type confgured, so we can pull the whole configuration across
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`DetailView inserting transferred widget type ${widgetName} across as whole type entity`);
                            }
                            this._widgetConfigWorkingCopy[widgetName] = this._userConfig.Widgets[widgetName];
                        }
                    }
                };
                // Housekeeping functions END. ==========================================================================================
                this._generateWidgetInstances = () => {
                    this._log.info("DetailLayoutBaseClass._generateWidgetInstances()");
                    this._status.setStatus(LayoutInitialisationStatus.CREATING_WIDGETS);
                    if (this._config.hasOwnProperty('Layout') && this._config.Layout.hasOwnProperty('Widgets')) {
                        // Need an instance count so we know when everything has been initialised
                        this._activatedWidgetCount = 0;
                        this._stashedWidgetCount = 0;
                        this._expectedWidgetCount = 0;
                        // Run through the instance loop counting how many we are expecting to create
                        // Annoying loop syntax - this is grabbing keys not values/objects
                        for (let widgetName in this._widgetConfigWorkingCopy) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`DetailLayoutBaseClass checking '${widgetName}' for instances`);
                            }
                            let widgetConfig = this._widgetConfigWorkingCopy[widgetName];
                            let hasAtLeastOneInstance = false;
                            if (!widgetConfig.hasOwnProperty("Disabled") || !widgetConfig.Disabled) {
                                if (widgetConfig.hasOwnProperty("Instance")) {
                                    widgetConfig.Instance.forEach(instance => {
                                        if (!instance.hasOwnProperty("Disabled") || !instance.Disabled)
                                            hasAtLeastOneInstance = true;
                                    });
                                }
                            }
                            if (hasAtLeastOneInstance)
                                this._expectedWidgetCount++;
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`DetailLayoutBaseClass excising reference to '${widgetName}' with no enabled instances`);
                                }
                                delete this._widgetConfigWorkingCopy[widgetName];
                            }
                        }
                        // This time we are actually instantiating the widgets
                        if (this._expectedWidgetCount > 0) {
                            for (let widgetName in this._widgetConfigWorkingCopy) {
                                let widgetConfig = this._widgetConfigWorkingCopy[widgetName];
                                if (widgetConfig.hasOwnProperty('Instance') && widgetConfig.Instance && widgetConfig.Instance.length > 0) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace(`Detail layout '${this._name}' attempting to instantiate widget type ${widgetName}`);
                                    }
                                    this._core.Widgets.createStandaloneWidget(widgetName, this._name, widgetConfig, this._widgetActivated).then(this._stashCreatedWidget);
                                }
                                else {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace(`Detail layout '${this._name}' not instantiating widget type ${widgetName} - no instance set`);
                                    }
                                }
                            }
                        }
                        else {
                            // No widgets to be instantiated, but that means stash and activate fuctions won't normally be called
                            if (this._widgetsReadyCallback)
                                this._widgetsReadyCallback();
                            this._status.setStatus(LayoutInitialisationStatus.WIDGETS_ACTIVE);
                        }
                    }
                };
                this._stashCreatedWidget = (widgetType) => {
                    this._log.info("DetailLayoutBaseClass._stashCreatedWidget()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Detail layout '${this._name}' stashing widget of type '${widgetType.getName()}'`);
                    }
                    widgetType.Instances.forEach(element => {
                        this._localInstances[element.getId()] = element;
                        this._localInstances.push(element);
                        this._instancesByPlaceholder[element.Container.id] = element;
                    });
                    this._stashedWidgetCount++;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Detail layout '${this._name}' stashed widget of type '${widgetType.getName()}'`);
                    }
                    if ((this._activatedWidgetCount == this._expectedWidgetCount) && (this._stashedWidgetCount == this._expectedWidgetCount)) {
                        if (this._widgetsReadyCallback)
                            this._widgetsReadyCallback();
                        this._status.setStatus(LayoutInitialisationStatus.WIDGETS_ACTIVE);
                    }
                };
                this._widgetActivated = (typeName) => {
                    this._log.info("DetailLayoutBaseClass._widgetActivated()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("widget '" + typeName + "' activated");
                    }
                    this._activatedWidgetCount++;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(this._activatedWidgetCount + " of " + this._expectedWidgetCount + " widgets activated");
                    }
                    if ((this._activatedWidgetCount == this._expectedWidgetCount) && (this._stashedWidgetCount == this._expectedWidgetCount)) {
                        if (this._widgetsReadyCallback)
                            this._widgetsReadyCallback();
                        this._status.setStatus(LayoutInitialisationStatus.WIDGETS_ACTIVE);
                    }
                };
                // To allow override specifically for processing incoming widgets with requested placeholders
                this.processTransferredWidgets = () => {
                    this._log.info("DetailLayoutBaseClass.processTransferredWidgets()");
                    if (this._context.hasOwnProperty("TransferWidgets") && (this._context.TransferWidgets != null)) {
                        this._context.TransferWidgets.forEach(request => {
                            if (request.hasOwnProperty('SelectedPlaceholder') && (request.SelectedPlaceholder != null)) {
                                let targetPlaceholder = this._containingDIV.querySelector(request.SelectedPlaceholder);
                                if (targetPlaceholder) {
                                    this._core.Widgets.Cache.popInstance(request.Instance.Handle, targetPlaceholder, this._name);
                                    this._instancesByPlaceholder[request.Instance.Container.id] = request.Instance;
                                    this._core.Widgets.Cache.deleteCachedInstance(request.Instance.getId());
                                }
                            }
                        });
                    }
                };
                this.handBackHomeInstances = () => {
                    this._log.info("DetailLayoutBaseClass.handBackHomeInstances()");
                    // Run through all the borrowed instance handing them back before we dispose of them and our layout
                    // Don't want to touch anything in the cache, as that's being passed elsewhere
                    let keys = Object.keys(this._instancesByPlaceholder);
                    keys.forEach(key => {
                        let instance = this._instancesByPlaceholder[key];
                        if ((instance.getOriginatingLayout() == Navigation.HOME_VIEW_NAME) && (instance.CurrentLayout != "[[-CACHE-]]") && (instance.CurrentLayout != "[[-FREEZER-]]")) {
                            let targetPlaceholder = document.querySelector(instance.getId());
                            instance.reparentInstance(targetPlaceholder, Navigation.HOME_VIEW_NAME);
                        }
                    });
                };
                this.getWidgetInstanceByPlaceholder = (placeholder) => {
                    this._log.info("DetailLayoutBaseClass.getWidgetInstanceByPlaceholder()");
                    if (placeholder in this._instancesByPlaceholder)
                        return this._instancesByPlaceholder[placeholder];
                    else
                        return null;
                };
                this.getWidgetInstances = () => {
                    this._log.info("DetailLayoutBaseClass.getWidgetInstances()");
                    return this._instancesByPlaceholder;
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DetailLayoutBaseClass::constructor");
                this._name = typeName;
                this._internalName = (typeName.includes(':')) ? typeName.split(':').shift() : typeName;
                this._handler = handler;
                this._context = context;
                this._widgetsReadyCallback = readyCallback;
                this._secondaryActivationCompleteCallback = secondaryActivationCallback;
                // Pull in Appliction-level user config
                let appConfig = this._core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty('DetailViews') && (appConfig.DetailViews != null) && appConfig.DetailViews.hasOwnProperty(this._name)) {
                    this._userConfig = appConfig.DetailViews[this._name];
                }
                if (this._userConfig == null)
                    this._userConfig = {};
                // Need a way to find functions with actual contexts or we have a lot of work to do
                this._status = new LayoutStatusCallbackHandler();
                this._status.setCallback(LayoutInitialisationStatus.LOADED_RESOURCES, this.activate, this, [this._context]);
                this._status.setCallback(LayoutInitialisationStatus.WIDGETS_ACTIVE, this._layoutInstancesActive, this, []);
                this._status.setCallback(LayoutInitialisationStatus.ACTIVE, this._postActivationActivity, this, []);
                // Load our assets - we know there are fedaults set up in the config object so don't need to check hasOwnProperty
                let mainConfig = this._core.Config.getMainConfig();
                let resourcePath = mainConfig.Resources.StandardDetailFiles;
                if (custom) {
                    resourcePath = mainConfig.Resources.CustomDetailFiles;
                    this._core.Loader.getUnversionedJSON(`${resourcePath}/detailConfig${this._internalName}.json`, this.loadConfig, this.initErrorCallback);
                    if (this._userConfig.hasOwnProperty('OverrideLayout') && (this._userConfig.OverrideLayout != null)) {
                        if (typeof this._userConfig.OverrideLayout != 'object') {
                            this._core.Loader.getUnversionedHTML(this._userConfig.OverrideLayout, this.loadTemplate, this.initErrorCallback);
                        }
                        else {
                            // Must be a remote config specification
                            let remoteSpec = {
                                Instance: this._userConfig.OverrideLayout.Instance,
                                FileType: 'VIEW-LAYOUT',
                                Id: this._userConfig.OverrideLayout.Id
                            };
                            this._core.Loader.retrieveConfigData(remoteSpec, this._receiveRemoteViewLayout, this.initErrorCallback);
                        }
                    }
                    else
                        this._core.Loader.getUnversionedHTML(`${resourcePath}/detailTemplate${this._internalName}.html`, this.loadTemplate, this.initErrorCallback);
                }
                else {
                    this._core.Loader.getVersionedJSON(`${resourcePath}/detailConfig${this._internalName}.json`, this.loadConfig, this.initErrorCallback);
                    if (this._userConfig.hasOwnProperty('OverrideLayout') && (this._userConfig.OverrideLayout != null)) {
                        if (typeof this._userConfig.OverrideLayout != 'object') {
                            this._core.Loader.getUnversionedHTML(this._userConfig.OverrideLayout, this.loadTemplate, this.initErrorCallback);
                        }
                        else {
                            // Must be a remote config specification
                            let remoteSpec = {
                                Instance: this._userConfig.OverrideLayout.Instance,
                                FileType: 'VIEW-LAYOUT',
                                Id: this._userConfig.OverrideLayout.Id
                            };
                            this._core.Loader.retrieveConfigData(remoteSpec, this._receiveRemoteViewLayout, this.initErrorCallback);
                        }
                    }
                    else
                        this._core.Loader.getVersionedHTML(`${resourcePath}/detailTemplate${this._internalName}.html`, this.loadTemplate, this.initErrorCallback);
                }
            }
            get OriginalLaunchContext() {
                return this._launchingContext;
            }
            /*
            * Fired after all the requested widgets have been generated
            */
            _layoutInstancesActive() {
                this._log.info("DetailLayoutBaseClass._layoutInstancesActive()");
                this._status.setStatus(LayoutInitialisationStatus.ACTIVE);
            }
            _postActivationActivity() {
                this._log.info("DetailLayoutBaseClass._postActivationActivity()");
                this._stashedContext = this._context;
                // Invite all widgets to advertise their services and respond
                let advertContext = new ActivationContext(null, LayoutActivationType.REQUEST_TO_ADVERTISE);
                for (let widgetPointer in this._instancesByPlaceholder) {
                    this._instancesByPlaceholder[widgetPointer].activate(advertContext);
                }
                this._context = this._stashedContext;
                this.secondaryActivation(this._context);
            }
            /*
            * Activates the layout and brings it to the front of the view
            *
            * WARNING: Do not do any widget-specific setup in this call - wait until _layoutInstacesLoaded is called.
            */
            activate(context, widgetsReadyCallback = null, secondaryCompleteCallback = null) {
                this._log.info("DetailLayoutBaseClass.activate()");
                if (context && this._log.isTraceEnabled()) {
                    this._log.trace(`Navigation.DetailLayoutBaseClass::activate() context is ${context.ActivationType}`);
                }
                this._status.setStatus(LayoutInitialisationStatus.PERFORMING_LAYOUT);
                this._context = context;
                this._launchingContext = context;
                this._containingDIV = context.TargetDIV;
                if (widgetsReadyCallback)
                    this._widgetsReadyCallback = widgetsReadyCallback;
                if (secondaryCompleteCallback)
                    this._secondaryActivationCompleteCallback = secondaryCompleteCallback;
                // Need to insert our layout HTML into the DOM at our _containingDIV
                this._containingDIV.innerHTML = this._layoutHTML;
                this._core.Functions.showElement(this._containingDIV);
                // Place widgets where they need to go - need to reset working copy of widget configuration
                this._mergeWidgetConfiguration();
                // Start by running through widget instance configuration and pulling anything relevant out of the transfer list
                if (this._log.isTraceEnabled()) {
                    this._log.trace("DetailLayoutBaseClass::activate() looking transfer targets amongst widgets");
                }
                for (let widgetName in this._widgetConfigWorkingCopy) {
                    let widgetConfig = this._widgetConfigWorkingCopy[widgetName];
                    if (widgetConfig.hasOwnProperty("Instance")) {
                        widgetConfig.Instance.forEach(instance => {
                            // Need to see if we are going to bypass this widget in favour of a transferred one
                            let widgetOveridden = false;
                            if (instance.hasOwnProperty('TransferPolicy') && (instance.TransferPolicy != null) && (instance.TransferPolicy.AllowOverride)) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Checking transfer policy on ${instance.PlaceHolder}`);
                                }
                                // First check if we want the activating widget specifically
                                if (instance.TransferPolicy.PreferActivatingWidget) {
                                    let request = this._context.TransferWidgets.find(r => r.IsActivatingWidget == true);
                                    if (request && (request.SelectedPlaceholder == null)) {
                                        if ((instance.TransferPolicy.AcceptWidgetTypes.indexOf(request.Instance.TypeName) != -1) || (instance.TransferPolicy.AcceptWidgetTypes.indexOf("*") != -1)) {
                                            if (this._log.isTraceEnabled()) {
                                                this._log.trace(`Overriding widget in ${instance.PlaceHolder} with ${request.Instance.Handle}`);
                                            }
                                            request.SelectedPlaceholder = instance.PlaceHolder;
                                            widgetOveridden = true;
                                            instance.Disabled = true;
                                        }
                                    }
                                }
                                // Not overridden yet, but may be other transferred widgets which qualify
                                if (!widgetOveridden) {
                                    for (let request of this._context.TransferWidgets) {
                                        if ((request.SelectedPlaceholder == null) && ((instance.TransferPolicy.AcceptWidgetTypes.indexOf(request.Instance.TypeName) != -1) || (instance.TransferPolicy.AcceptWidgetTypes.indexOf("*") != -1))) {
                                            if (this._log.isTraceEnabled()) {
                                                this._log.trace(`Overriding widget in ${instance.PlaceHolder} with ${request.Instance.Handle}`);
                                            }
                                            request.SelectedPlaceholder = instance.PlaceHolder;
                                            widgetOveridden = true;
                                            instance.Disabled = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
                // Next stage is to run through any unplaced transferred widgets and see if we can place them
                if (this._log.isTraceEnabled()) {
                    this._log.trace("DetailLayoutBaseClass::activate() checking for target slots");
                }
                if (this._config.Layout.hasOwnProperty('TransferPlaceholders')) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("DetailLayoutBaseClass::activate() looking transfer targets amongst empty target slots");
                    }
                    let slots = this._config.Layout.TransferPlaceholders;
                    // Process by slot, not by transfer request, as active widget matching is easier
                    for (let placeholderName in slots) {
                        let slot = slots[placeholderName];
                        // Need to know if the slot has been filled
                        if (!slots.hasOwnProperty('Applied'))
                            slot.Applied = false;
                        if (slot.PreferActivatingWidget) {
                            let request = this._context.TransferWidgets.find(r => r.IsActivatingWidget == true);
                            if (request && (request.SelectedPlaceholder == null)) {
                                if ((slot.AcceptWidgetTypes.indexOf(request.Instance.TypeName) != -1) || (slot.AcceptWidgetTypes.indexOf("*") != -1)) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace(`Using empty slot ${placeholderName} for activating widget with ${request.Instance.Handle}`);
                                    }
                                    request.SelectedPlaceholder = placeholderName;
                                    slot.Applied = true;
                                }
                            }
                        }
                        // Activating widget didn't conform to type or wasn't available
                        if (!slot.Applied) {
                            for (let request of this._context.TransferWidgets) {
                                if ((request.SelectedPlaceholder == null) && ((slot.AcceptWidgetTypes.indexOf(request.Instance.TypeName) != -1) || (slot.AcceptWidgetTypes.indexOf("*") != -1))) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace(`Using empty slot ${placeholderName} for widget with ${request.Instance.Handle}`);
                                    }
                                    request.SelectedPlaceholder = placeholderName;
                                    slot.Applied = true;
                                    break;
                                }
                            }
                        }
                    }
                }
                // Pull the transferred items in
                this.processTransferredWidgets();
                // We create any required widgets on activation and dispose of them when deactivated
                this._generateWidgetInstances();
                if (this._log.isTraceEnabled()) {
                    this._log.trace(`Navigation.DetailLayoutBaseClass::activate() completed`);
                }
            }
            deactivate() {
                this._log.info("DetailLayoutBaseClass.deactivate()");
                if (this._log.isTraceEnabled()) {
                    this._log.trace(`Layout '${this._name}' received deactivation request`);
                }
                this._status.setStatus(LayoutInitialisationStatus.DEACTIVATING);
                this.handBackHomeInstances();
                this._instancesByPlaceholder = {};
                this._localInstances = [];
                this._context = null;
                this._status.setStatus(LayoutInitialisationStatus.DORMANT);
            }
            // Called when in receipt of an activation message, but layout is already the active one
            secondaryActivation(context) {
                if (this._log.isTraceEnabled()) {
                    this._log.trace(`DetailLayoutBaseClass.secondaryActivation fired with ${context.ActivationType}`);
                }
                else
                    this._log.info("DetailLayoutBaseClass.secondaryActivation()");
                this._context = context;
                // We may have all sorts of widgets here, so delegate event handling to them
                for (let widgetPointer in this._instancesByPlaceholder) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Navigation.DetailLayoutBaseClass::secondaryActivation activating '${widgetPointer}' under status '${this._status.getStatus()}'`);
                    }
                    if (this._status.allowWidgetActivations())
                        this._instancesByPlaceholder[widgetPointer].activate(context);
                }
                // Call back once done to restart event loop
                if (this._secondaryActivationCompleteCallback)
                    this._secondaryActivationCompleteCallback();
            }
        }
        Navigation.DetailLayoutBaseClass = DetailLayoutBaseClass;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
